import React, { MouseEvent } from "react";

export const CheckNeedMIcon: React.FC<{
    fontSize?: string;
    onClick?: (e: MouseEvent<HTMLDivElement>) => void;
}> = ({ fontSize, onClick }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 -960 960 960"
            width="24px"
            fill="#fff"
        >
            <path d="M636-592q-12-12-28.5-12.5T579-593l-21 21q-12 12-12 28.5t12 28.5q12 12 28.5 12t28.5-12l21-21q12-12 11.5-28T636-592ZM480-842l104-44q14-6 28-1.5t22 17.5l58 98 110 24q15 3 24 15.5t7 27.5l-11 113 75 86q10 11 10 26t-10 26l-75 86 3 35q2 17-8.5 29T789-290q-17 2-29-8.5T746-326l-6-70 74-84-74-86 10-112-110-24-58-96-102 44-104-44-11 19q-8 14-24.5 18t-30.5-4q-14-8-18-24.5t4-30.5l30-50q8-13 22-17.5t28 1.5l104 44ZM378-162l102-44 104 44 38-64-148-148-8 8q-12 12-28 12t-28-12l-86-86q-11-11-11.5-27.5T324-508q11-11 27.5-11.5T380-509l58 57-21 21-203-203 6 68-74 86 74 84-10 114 110 24 58 96Zm-52 72-58-98-110-24q-15-3-24-15.5t-7-27.5l11-113-75-86q-10-11-10-26t10-26l75-86-12-130-42-42q-11-11-11-28t11-28q11-11 28-11t28 11l680 680q11 11 11 28t-11 28q-11 11-28 11t-28-11l-84-84-46 78q-8 13-22 17.5T584-74l-104-44-104 44q-14 6-28 1.5T326-90Zm232-425Zm-174 51Z" />
        </svg>
    );
};
